import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
const { firebaseConnect } = require('react-redux-firebase');

import { RootState } from '../reducers/root';
import LoginForm from '../components/forms/loginForm';
import AdminDashboard from '../components/adminDashboard';

import './admin.css';

interface AdminPageStateProps {
  auth: {
    isLoaded: boolean;
    isEmpty: boolean;
  };
  authError: any; // tslint:disable-line:no-any
}

interface AdminPageRouterProps extends RouteComponentProps<{}> {}

interface AdminPageProps extends AdminPageStateProps, AdminPageRouterProps {
  firebase: {
    push: (path: string, data: any) => void; // tslint:disable-line:no-any
    login: ({ email, password }: { email: string; password: string }) => Promise<void>;
  };
}

class AdminPage extends React.PureComponent<AdminPageProps, {}> {
  content(): JSX.Element {
    if (!this.props.auth.isLoaded || this.props.auth.isEmpty) {
      return <LoginForm onSignIn={this.props.firebase.login} authError={this.props.authError} />;
    }
    return <AdminDashboard />;
  }

  render(): JSX.Element {
    return (
      <section className="section admin escape-nav">
        <div className="container">{this.content()}</div>
      </section>
    );
  }
}

function mapStateToProps(state: RootState, _ownProps: AdminPageRouterProps): AdminPageStateProps {
  return {
    auth: state.firebase.auth,
    authError: state.firebase.authError,
  };
}

export default connect(mapStateToProps)(firebaseConnect()(AdminPage));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/admin.tsx